// extracted by mini-css-extract-plugin
export default {"logo":"WhyPMToolsPage_logo__sKh6S","about":"WhyPMToolsPage_about__H2T8r"};